<template>
  <div class="locale-changer" v-if="allLangs.length > 1">
    <a
      href="#"
      v-for="(lang, i) in langs"
      :key="`Lang${i}`"
      v-text="$t(lang)"
      @click.prevent="$router.push({ params: { locale: lang } })"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'locale-changer',
  computed: {
    ...mapGetters(['messages']),
    allLangs () {
      return Object.keys(this.messages)
    },
    langs () {
      return this.allLangs.filter((lang) => lang !== this.$route.params.locale)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #42b983;
  text-decoration: none;
  color: black;
  background: rgba(255, 255, 255, 0.6);
  padding: 0.625rem 1rem;
  border-radius: 0.5rem;
}
</style>
